import React from 'react';
import styled from 'styled-components';

const SidebarLinksContainerWrapper = styled.div`
  border-left: 0.8rem solid ${(props) => props.color};
  padding: 0.25rem 1.5rem;
  margin: 2rem 0px;
  .slc-title {
    font-size: 2.6rem;
    color: ${(props) => props.color};
  }
  .slc-links-container {
    display: grid;
    grid-template-areas: ${(props) => (props.grid_1D ? 'one' : 'one two')};
    grid-template-columns: ${(props) => (props.grid_1D ? '1fr' : '1fr 1fr')};
    grid-column-gap: 0.5rem;
    grid-row-gap: 1.2rem;
    margin-top: 0.75rem;
    .slc-link {
      box-sizing: border-box;
      font-size: 1.6rem;
      min-width: fit-content;
      width: fit-content;
      word-wrap: wrap none;
      text-align: left;
      height: 100%;
      border: 0px;
      cursor: pointer;
      & > a {
        color: var(--color-black);
        text-decoration: none;
        border-bottom: 1px solid transparent;
        &:hover {
          border-bottom: 1px solid var(--color-black);
        }
      }
    }
  }
`;

const SidebarLinksContainer = ({ links_list, color, grid_1D }) => {
  return (
    <SidebarLinksContainerWrapper color={color} grid_1D={grid_1D}>
      <div className="slc-title">{links_list.title}</div>
      <div className="slc-links-container">
        {links_list.list.map((ele) => {
          return (
            <div className="slc-link" key={ele.title.replace(' ', '').toLocaleLowerCase()}>
              <a
                href={ele.link}
                title={ele.title}
                target={ele.target ? '_blank' : '_self'}
                rel="noopener noreferrer"
              >
                {ele.title}
              </a>
            </div>
          );
        })}
      </div>
    </SidebarLinksContainerWrapper>
  );
};

export default SidebarLinksContainer;
